'use strict';

const { h } = require('phy');
const { connect } = require('preact-redux');

const HeroTitle = require('../../coupons/views/hero-title');
const MainMenu = require('../../header/views/main-menu');
const LayoutServiceLinks = require('../../header/views/layout-service-links');
const AlertBar = require('../../../components/alert_bar');

function getHeaderElements({
  showTitleOntouch,
  isTouch,
  layoutServiceMenu,
  resourceKey,
  params,
  titleText,
  tag,
  searchCredentials,
  merchants,
  activePage,
  routes,
  blogUrl,
  themedPage,
  showTopOffers,
  alertAdvert,
}) {
  const layoutServiceLinks = h(LayoutServiceLinks, { layoutServiceMenu });
  const heroTitle = HeroTitle({ resourceKey, params, titleText, tag });
  const mainMenu = h(MainMenu, {
    searchCredentials,
    merchants,
    activePage,
    routes,
    isTouch,
    blogUrl,
    themedPage,
    showTopOffers,
  });
  const alertBar = h(AlertBar, { advert: alertAdvert });

  if (isTouch && showTitleOntouch) {
    return [layoutServiceLinks, mainMenu, heroTitle, alertBar];
  }
  if (!isTouch) {
    return [layoutServiceLinks, heroTitle, mainMenu, alertBar];
  }
  return [layoutServiceLinks, mainMenu, alertBar];
}

function Header({
  showTitleOntouch = true,
  isTouch,
  layoutServiceMenu,
  resourceKey,
  params,
  titleText,
  tag,
  searchCredentials,
  merchants,
  activePage,
  routes,
  blogUrl,
  themedPage,
  showTopOffers,
  alertAdvert,
}) {
  return h(
    'section',
    getHeaderElements({
      showTitleOntouch,
      isTouch,
      layoutServiceMenu,
      resourceKey,
      params,
      titleText,
      tag,
      searchCredentials,
      merchants,
      activePage,
      routes,
      blogUrl,
      themedPage,
      showTopOffers,
      alertAdvert,
    })
  );
}

const mapStateToProps = state => ({
  blogUrl: state.blogUrl,
  isTouch: state.isTouch,
  layoutServiceMenu: state.layoutServiceMenu,
  alertAdvert: state.alertAdvert,
  themedPage: state.themedPage,
  showTopOffers: state.showTopOffers,
  searchCredentials: state.searchCredentials,
});

module.exports = connect(mapStateToProps)(Header);
